const initRhheaderData = {
  
}


export function rhheaderData(
  state = initRhheaderData,
  action
) {
  switch (action.type) {
    case "RH_HEADER_FETCH_DATA_SUCCESS":
      return action.dataRhheader;
    default:
      return state;
  }
}
